const MIME_TO_EXTENSION = {
  "image/jpeg": "jpg",
  "image/jpg": "jpg",
  "image/png": "png",
  "image/gif": "gif",
  "image/webp": "webp",
  "image/avif": "avif",
  "video/mp4": "mp4",
  "video/webm": "webm",
  "video/ogg": "ogg",
};

function getExtensionFromMime(mimeString) {
  if (MIME_TO_EXTENSION[mimeString]) {
    return MIME_TO_EXTENSION[mimeString];
  }
  const subtype = (mimeString.split("/")[1] || "bin").split("+")[0];
  return subtype === "jpeg" ? "jpg" : subtype;
}

export default function dataURItoBlob(dataURI, filename = null) {
  // convert base64/URLEncoded data component to raw binary data held in a string
  var byteString;
  if (dataURI.split(",")[0].indexOf("base64") >= 0)
    byteString = atob(dataURI.split(",")[1]);
  else byteString = unescape(dataURI.split(",")[1]);

  // separate out the mime component
  var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
  var extension = getExtensionFromMime(mimeString);

  if (!filename) {
    const prefix = mimeString.startsWith("video/") ? "video" : "image";
    filename = `${prefix}_${Date.now()}.${extension}`;
  } else {
    // Always keep the real mime-based extension (don't force .jpg/.mp4)
    const baseName = filename.replace(/\.[^/.]+$/, "");
    filename = `${baseName}.${extension}`;
  }

  // write the bytes of the string to a typed array
  var ia = new Uint8Array(byteString.length);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  // Return a File object with a name
  return new File([ia], filename, { type: mimeString });
}
